import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Done } from "@mui/icons-material";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import moment from "moment";
import {
  getUserAccessRequests,
  getUserStatus,
  putUserAccessRequest,
  resetAll,
} from "../../redux/slices/userDataSlice";
import ApproveUser from "./approved";
import RejectUser from "./reject";
import { setPage } from "../../redux/slices/userDataSlice";
import { ROLES } from "../../utils/constants";

const AccessModal = () => {
  const dispatch = useDispatch();

  const state = useSelector(
    ({
      userData: { modalUsers, hasNextPage, page, loading, isInput, statusus },
    }) => ({
      modalUsers,
      hasNextPage,
      page,
      loading,
      isInput,
      statusus,
    })
  );

  const roleState = useSelector(
    ({
      seller: {
        msal: { roles },
      },
    }) => ({ roles })
  );
  console.log(roleState);
  const [option, setOption] = React.useState("DS004");

  const theme = useTheme();
  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : "44.875rem",
    height: isMobile ? "95%" : "90%",
    bgcolor: "background.paper",
    border: "2px solid #B9D9EB",
    boxShadow: 24,
    borderRadius: "1rem",
    overflowY: "scroll",
  };

  const [sentryRef] = useInfiniteScroll({
    loading: state.loading,
    hasNextPage: state.hasNextPage,
    onLoadMore: () => dispatch(setPage()),
    rootMargin: "400px 0px 0px 0px",
  });

  React.useEffect(() => {
    dispatch(
      getUserAccessRequests({
        params: {
          offset: 0,
          status: option,
        },
        change: true,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, state.page]);

  React.useEffect(() => {
    if (state.page > 0) {
      dispatch(
        getUserAccessRequests({
          params: {
            offset: state.page,
            status: option,
          },
          change: false,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page]);

  React.useEffect(() => {
    dispatch(
      getUserStatus({
        params: {},
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.statusus?.pending_count]);

  const handleButton = (data) => {
    dispatch(putUserAccessRequest({ data }));
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const selectOption = [
    {
      value: "DS004",
      label: "New",
    },
    {
      value: "DS002",
      label: "Approved(manually)",
    },
    {
      value: "DS003",
      label: "Rejected",
    },
  ];

  return (
    <div>
      {roleState.roles.some(
        (role) => role === ROLES.SUPER_ADMIN || role === ROLES.IT_ADMIN
      ) ? (
        <Button
          onClick={handleOpen}
          sx={{
            width: "14.375rem",
            height: "3rem",
            borderRadius: 3,
            bgcolor: "#FFFFFF",
            weight: 600,
            font: "Open Sans",
            fontSize: "1rem",
            textTransform: "none",
          }}
        >
          <PersonAddAltOutlinedIcon sx={{ mr: "1rem" }} />
          Access Request ({state?.statusus?.pending_count || 0})
        </Button>
      ) : null}

      <Modal
        open={open}
        sx={{ zIndex: 130000 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: isMobile ? "100%" : "44.875rem",
              height: "4.5rem",
              borderRadius: "0.75rem 0.75rem 0rem 0rem",
              bgcolor: "#FFFFFF",
              boxShadow: "0 0 1rem #ccc",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                ml: "2rem",
                mt: "1.5rem",
                color: "#000000",
                fontWeight: 600,
                fontFamily: "Open Sans",
                fontSize: "1.25rem",
              }}
            >
              Access Request
            </Typography>
            <Button
              onClick={handleClose}
              sx={{
                width: "1.5rem",
                height: "1.5rem",
                mt: "1.5rem",
                color: "#000000",
              }}
            >
              <CloseIcon />
            </Button>
          </Grid>
          <Box>
            <Typography
              sx={{
                color: "#4A4F55",
                fontSize: "0.75rem",
                font: "Open Sans",
                lineHeight: "1.125rem",
                ml: isMobile ? "1rem" : "2rem",
                mt: "1.5rem",
                weight: 400,
              }}
              // gutterBottom
            >
              Status
            </Typography>
            <Select
              value={option}
              renderValue={(value) => {
                const lab = selectOption.find(
                  (opt) => opt.value === value
                )?.label;
                if (lab === "New") {
                  return `New(${state?.statusus?.pending_count || 0})`;
                }
                return lab;
              }}
              onChange={(e) => {
                dispatch(
                  getUserAccessRequests({
                    params: {
                      offset: state.page,
                      status: e.target.value,
                    },
                    change: true,
                  })
                );
                dispatch(resetAll());
                setOption(e.target.value);
              }}
              variant="standard"
              sx={{
                width: isMobile ? "90%" : "19.5rem",
                color: "#000000",
                ml: isMobile ? "1rem" : "2rem",
              }}
              MenuProps={{ style: { zIndex: 130000 } }}
            >
              {selectOption.map((opt) => (
                <MenuItem
                  value={opt.value}
                  sx={{
                    fontFamily: "Open Sans",
                    fontWeight: "400",
                    fontSize: "1rem",
                    lineHeight: "1.25rem",
                    color: "#000000",
                    zIndex: "130000002",
                  }}
                  fullWidth
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      {opt.label === "New"
                        ? `New(${state?.statusus?.pending_count || 0})`
                        : opt.label}{" "}
                    </span>
                    {option === opt.value && (
                      <Done sx={{ color: theme.palette.darkBlue }} />
                    )}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Box>
            {option === "DS002" && (
              <ApproveUser
                modalUsers={state?.modalUsers}
                hasNextPage={state.hasNextPage}
                page={state.page}
                loading={state.loading}
              />
            )}
            {option === "DS003" && (
              <RejectUser
                modalUsers={state?.modalUsers}
                hasNextPage={state.hasNextPage}
                page={state.page}
                loading={state.loading}
              />
            )}
            {option === "DS004" &&
              state?.modalUsers?.map((user, index) => (
                <Grid
                  xs={12}
                  sm={11}
                  lg={11}
                  container
                  spacing={1}
                  sx={{
                    display: "flex",
                    borderRadius: "0.5rem",
                    bgcolor: "#FFFFFF",
                    border: "1px solid #B9D9EB",
                    width: isMobile ? "90%" : "40.875rem",
                    // height: "11.125rem",
                    ml: isMobile ? "1rem" : "2rem",
                    // mr:"",
                    mt: "1.5625rem",
                    wordBreak: "break-all",
                  }}
                >
                  <Grid xs={12} md={12} lg={12}>
                    <Typography
                      variant="h6"
                      fontWeight={"600"}
                      fontSize={"1.25rem"}
                      lineHeight={"1.625rem"}
                      color={"#000000"}
                      mt={"1.5rem"}
                      ml={"1.5rem"}
                    >
                      {user.user_email}
                    </Typography>
                    <Typography
                      fontWeight={"400"}
                      fontSize={"0.875rem"}
                      lineHeight={"1.5rem"}
                      color={"#000000"}
                      mt={".5rem"}
                      ml={"1.5rem"}
                      wordBreak={"break-all"}
                    >
                      {user.company_name} | Requested by {user.requested_by} on{" "}
                      {user.requested_on &&
                        moment(user.requested_on).utc().format("MMM DD YYYY")}
                    </Typography>
                  </Grid>

                  <Grid
                    sx={{
                      display: "flex",
                      mt: "0.5rem",
                      mb: "1rem",
                      justifyContent: "space-between",
                      flexDirection: isMobile ? "column" : "row",
                      width: isMobile ? "95%" : "18.4375rem",
                    }}
                  >
                    <Grid item xs={12} md={6}>
                      <Button
                        onClick={() =>
                          handleButton({
                            domain_status_id: "DS002",
                            id: user.user_id,
                            currentOption: option,
                          })
                        }
                        variant="contained"
                        sx={{
                          borderRadius: 3,
                          width: isMobile ? "95%" : "18.4375rem",
                          // width:'18.4375rem',
                          height: "3rem",
                          mt: "1.5rem",
                          ml: "1.5rem",
                          fontSize: "1rem",
                          textTransform: "none",
                          lineHeight: "1.5rem",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          bgcolor: "#005078",
                        }}
                      >
                        Approve User
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <Button
                        onClick={() => {
                          handleButton({
                            domain_status_id: "DS003",
                            id: user.user_id,
                          });
                        }}
                        // variant="contained"
                        sx={{
                          borderRadius: 3,
                          // width:'18.4375rem',
                          width: isMobile ? "95%" : "18.4375rem",
                          height: "3rem",
                          mt: "1.5rem",
                          ml: isMobile ? "1.5rem" : "11.5rem",
                          fontSize: "1rem",
                          textTransform: "none",
                          lineHeight: "1.5rem",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          bgcolor: "#FFFFFF",
                          color: "#005078",
                        }}
                      >
                        Reject User
                      </Button>
                    </Grid>
                  </Grid>

                  {state.modalUsers.length - 1 === index &&
                    state.modalUsers.length >= 12 &&
                    state.hasNextPage && (
                      <Box
                        ref={sentryRef}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          py: "5rem",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    )}
                </Grid>
              ))}
            <Box sx={{ display: "flex", py: "1.5rem" }}>
              {state.loading && !state.isInput && !state.modalUsers.length ? (
                <CircularProgress sx={{ m: "0 auto" }} />
              ) : null}
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default AccessModal;
